var _path, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M22.657,19.994c0,1.471-1.192,2.664-2.664,2.664 H4.007c-1.472,0-2.665-1.193-2.665-2.664V4.007c0-1.472,1.193-2.665,2.665-2.665h15.986c1.472,0,2.664,1.193,2.664,2.665V19.994z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 6.512,12.215 10.029,15.727 17.488,8.274 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareCheck);
export default __webpack_public_path__ + "static/media/square_check.df7c8f9875b64dfe39fd4f4fb43f266e.svg";
export { ForwardRef as ReactComponent };